import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { Orgao } from '../models/orgao.model';

@Injectable({
  providedIn: 'root',
})
export class OrgaoService extends BaseService<Orgao>{

  constructor(public http: HttpClient) {
    super(http)
  }

  public getOrganUser(id: any): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/' + id, { headers: this.headers });
  }

  public getOrgaosAll(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-all', { headers: this.headers });
  }

  public getOrgaosPrograma(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-programa', { headers: this.headers });
  }

  public getOrgaosAgregador(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-agregador', { headers: this.headers });
  }

  public getPathModule(): string {
    return '/orgaos';
  }

  public getAll(id: number = null) {
    return this.http.get<any>((id != null) ? this.baseUrl + '?projeto_id=' + id : this.baseUrl, { headers: this.headers });
  }
}
